module.exports = __webpack_public_path__ + "static/media/Revive Joondalup - Ryan Ngaw.6d77720e.jpg";